import React, { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import { cluster_regions } from '../../data/cluster_data/cluster_regions.js';
import sheep from '../../data/cluster_data/sheep.json';
import meat from '../../data/cluster_data/meat.json';
import tribal from '../../data/cluster_data/tribal.json';
import airports from '../../data/cluster_data/airports.json';
import sheep_png from '../../assets/cluster_icons/sheep.png';
import airport_png from '../../assets/cluster_icons/airport.png';

function ClusterMap(props) {
  const mapContainer = useRef();

  useEffect(() => {
    if (window.cluster_map) return;
    window.cluster_map = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [68.71584352632227, 48.58775813682156],
      zoom: 4.5,
      dragRotate: false,
    });
    window.cluster_map.on('load', () => {
      window.cluster_map.loadImage(sheep_png, (error, image) => {
        if (error) throw error;
        window.cluster_map.addImage('sheep', image);
      });
      window.cluster_map.loadImage(airport_png, (error, image) => {
        if (error) throw error;
        window.cluster_map.addImage('airport', image);
      });

      window.cluster_map.addSource('cluster_regions_source', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: cluster_regions,
        },
      });
      window.cluster_map.addSource('cluster_sheep_source', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: sheep,
        },
      });
      window.cluster_map.addSource('cluster_meat_source', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: meat,
        },
      });
      window.cluster_map.addSource('cluster_tribal_source', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: tribal,
        },
      });
      window.cluster_map.addSource('cluster_airports_source', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: airports,
        },
      });

      window.cluster_map.addLayer({
        id: 'cluster_regions_layer',
        type: 'fill',
        source: 'cluster_regions_source',
        paint: {
          'fill-color': ['get', 'color'],
          'fill-opacity': 0.8,
        },
      });

      window.cluster_map.addLayer({
        id: 'cluster_meat_layer',
        type: 'circle',
        source: 'cluster_meat_source',
        paint: {
          'circle-color': '#c0504d',
          'circle-radius': 10,
          'circle-stroke-color': '#8c3836',
          'circle-stroke-width': 5,
        },
      });
      window.cluster_map.addLayer({
        id: 'cluster_meat_count_layer',
        type: 'symbol',
        source: 'cluster_meat_source',
        layout: {
          'text-field': ['get', 'count'],
          'text-size': 12,
        },
      });

      window.cluster_map.addLayer({
        id: 'cluster_tribal_layer',
        type: 'circle',
        source: 'cluster_tribal_source',
        paint: {
          'circle-color': '#f79646',
          'circle-radius': 10,
          'circle-stroke-color': '#ce7d38',
          'circle-stroke-width': 5,
        },
      });
      window.cluster_map.addLayer({
        id: 'cluster_tribal_count_layer',
        type: 'symbol',
        source: 'cluster_tribal_source',
        layout: {
          'text-field': ['get', 'count'],
          'text-size': 12,
        },
      });

      window.cluster_map.addLayer({
        id: 'cluster_airports_layer',
        source: 'cluster_airports_source',
        type: 'symbol',
        layout: {
          'icon-image': 'airport',
        },
      });

      window.cluster_map.addLayer({
        id: 'cluster_sheep_layer',
        source: 'cluster_sheep_source',
        type: 'symbol',
        layout: {
          'icon-image': 'sheep',
          'text-field': ['get', 'count'],
          'text-offset': [2, 0],
        },
      });
    });
  }, []);

  return <div ref={mapContainer} className="map-container" />;
}

export default ClusterMap;
